import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import * as LotActionType from '../constants';

class HomeOwnerManageLot extends Component {
  static propTypes = {
    match: PropTypes.object,
    history: PropTypes.object,
    location: PropTypes.object,
    dispatch: PropTypes.func,
    HomeownerLots: PropTypes.array
  };

  componentDidMount() {
    this.props.dispatch({
      type: LotActionType.GET_HOMEOWNER_LOT_LIST_ASYNC
      // callbackRedirectToLotDetail: (lotId) => {
      //   this.props.history.push(`lots/${lotId}`);
      // }
    });
    this.props.dispatch({
      type: LotActionType.RESET_LOT_PROFILE
    });
  }

  onClickNewRFS = (e, item) => {
    e.preventDefault();
    this.props.history.push(`/lot/${item.lot.id}/request/add`);
  };

  renderLotOwners = lotOwners => {
    return (
      <React.Fragment>
        <div
          style={{
            marginBottom: 10,
            fontSize: 16,
            fontWeight: 500,
            color: '#4d4d4d'
          }}
        >
          Lots that you own
        </div>
        <ul className='homeowner-manage-lot-list' style={{ marginBottom: 60 }}>
          {lotOwners.map(item => {
            return (
              <li key={item.lot.id}>
                <Link to={`lots/${item.lot.id}`}>
                  <span className='lot-record'>
                    <span className='lot-name'>{item.lot.name}</span>
                    <span className='lot-address'>
                      <i className='address-ic fa fa-map-marker' />
                      {item.lot.streetAddress}
                    </span>
                  </span>
                  <span className='lot-add-rfs'>
                    <button
                      className='btn btn-siteone'
                      onClick={e => this.onClickNewRFS(e, item)}
                    >
                      <i className='fa fa-plus' />
                      Request for service
                    </button>
                  </span>
                  <span className='lot-direct'>
                    <i className='direct-ic fa fa-angle-right' />
                  </span>
                </Link>
              </li>
            );
          })}
        </ul>
      </React.Fragment>
    );
  };

  renderLotTenancies = tenancies => {
    return (
      <React.Fragment>
        <div
          style={{
            marginBottom: 10,
            fontSize: 16,
            fontWeight: 500,
            color: '#4d4d4d'
          }}
        >
          Lots that I rent
        </div>
        <ul className='homeowner-manage-lot-list'>
          {tenancies.map(item => {
            return (
              <li key={item.lot.id}>
                <Link to={`lots/${item.lot.id}`}>
                  <span
                    className='lot-record'
                    style={{ width: '96%', padding: '7px 0' }}
                  >
                    <span className='lot-name'>{item.lot.name}</span>
                    <span className='lot-address'>
                      <i className='address-ic fa fa-map-marker' />
                      {item.lot.streetAddress}
                    </span>
                  </span>
                  <span className='lot-direct'>
                    <i className='direct-ic fa fa-angle-right' />
                  </span>
                </Link>
              </li>
            );
          })}
        </ul>
      </React.Fragment>
    );
  };

  render() {
    const lotOwners = this.props.HomeownerLots.filter(
      x => x.owner && x.owner.status === 1
    );
    const tenancies = this.props.HomeownerLots.filter(
      x => x.tenancy && x.tenancy.status === 1
    );
    return (
      <div className='homeowner-manage-lot-wrapper'>
        <div className=''>
          <div className=' homeowner-manage-lot clearfix'>
            {lotOwners.length > 0 && this.renderLotOwners(lotOwners)}
            {tenancies.length > 0 && this.renderLotTenancies(tenancies)}
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    HomeownerLots: state.LotStore.HomeownerLots
  };
};

export default connect(mapStateToProps)(HomeOwnerManageLot);



// WEBPACK FOOTER //
// ./src/Lots/Containers/lot-list.js